import { render, staticRenderFns } from "./CreateOtherSupplierCategoryPopUp.vue?vue&type=template&id=6334168f&scoped=true&"
import script from "./CreateOtherSupplierCategoryPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateOtherSupplierCategoryPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateOtherSupplierCategoryPopUp.vue?vue&type=style&index=0&id=6334168f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6334168f",
  null
  
)

export default component.exports